/* eslint-disable @change/sibling-module-imports */
import { Translate } from '@change-corgi/core/react/i18n';
import { Avatar } from '@change-corgi/design-system-legacy/components/media';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import type { Comment } from '../../../../../pageContext';

import { useCommentHeader } from './hooks/useCommentHeader';

type Props = {
	comment: Comment;
};

export function CommentHeader({ comment }: Props) {
	const {
		// data: { author, authorUrl, authorAvatar, dateRelative },
		data: { author, authorAvatar, dateRelative },
	} = useCommentHeader(comment);

	return (
		<Flex sx={{ alignItems: 'center' }}>
			<Avatar alt="avatar" size="xs" src={authorAvatar} variant="subtle" />
			<Text as="p" ml="8px">
				<Text as="span">
					<b>{author}</b>{' '}
					<Translate value="corgi.petition.starter_dashboard.petition_comments.comments_list.commented_by" />{' '}
					{dateRelative}
				</Text>
			</Text>
		</Flex>
	);
}
